import React, { useState, useEffect } from 'react';

export default function ShowcaseAdminPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({ total: 0, public: 0, today: 0 });
  const [filter, setFilter] = useState('all');

  const fetchItems = async () => {
    setLoading(true);
    try {
      var url = '/cms/api/showcase/ai-mall';
      if (filter !== 'all') url += '?status=' + filter;
      var res = await fetch(url);
      var data = await res.json();
      if (data.success) setItems(data.data || []);
    } catch(e) {
      console.error(e);
    }
    setLoading(false);
  };

  const fetchStats = async () => {
    try {
      var res = await fetch('/cms/api/showcase/ai-mall/stats');
      var data = await res.json();
      if (data.success) setStats(data.data);
    } catch(e) {}
  };

  useEffect(() => {
    fetchStats();
    fetchItems();
  }, [filter]);

  const toggleItem = async (id) => {
    try {
      var res = await fetch(`/cms/api/showcase/ai-mall/${id}/toggle`, { method: 'POST' });
      var data = await res.json();
      if (data.success) {
        setItems(items.map(function(i) {
          return i.id === id ? { ...i, is_public: data.data.is_public } : i;
        }));
      }
    } catch(e) {}
  };

  const deleteItem = async (id) => {
    if (!confirm('确定删除该作品？')) return;
    try {
      var res = await fetch(`/cms/api/showcase/ai-mall/${id}`, { method: 'DELETE' });
      var data = await res.json();
      if (data.success) {
        setItems(items.filter(function(i) { return i.id !== id; }));
        fetchStats();
      }
    } catch(e) {}
  };

  var filterTabs = [
    { key: 'all', label: '全部' },
    { key: 'public', label: '✅ 已上架' },
    { key: 'hidden', label: '🔒 已下架' },
  ];

  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: '0 auto' }}>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}>🎬 作品墙管理</h2>
      <p style={{ color: '#888', marginBottom: 20 }}>管理 AI 广场作品墙的展示内容</p>

      {/* 统计卡片 */}
      <div style={{ display: 'flex', gap: 16, marginBottom: 24 }}>
        {[
          { label: '作品总数', value: stats.total, color: '#667eea' },
          { label: '已公开', value: stats.public, color: '#38a169' },
          { label: '今日新增', value: stats.today, color: '#f6ad55' },
        ].map(function(s) { return (
          <div key={s.label} style={{ flex: 1, background: '#fff', borderRadius: 12, padding: '20px 24px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderLeft: '4px solid ' + s.color }}>
            <div style={{ fontSize: 13, color: '#999' }}>{s.label}</div>
            <div style={{ fontSize: 28, fontWeight: 700, color: '#333', marginTop: 4 }}>{s.value}</div>
          </div>
        );})}
      </div>

      {/* 筛选 */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {filterTabs.map(function(t) { return (
          <button key={t.key}
            onClick={function() { setFilter(t.key); }}
            style={{
              padding: '6px 16px', borderRadius: 20, border: '1.5px solid ' + (filter === t.key ? '#667eea' : '#e0e0e0'),
              background: filter === t.key ? '#667eea' : '#fff',
              color: filter === t.key ? '#fff' : '#666',
              fontSize: 13, cursor: 'pointer', fontWeight: 500,
            }}
          >{t.label}</button>
        );})}
      </div>

      {/* 列表 */}
      {loading ? (
        <div style={{ textAlign: 'center', color: '#999', padding: 48 }}>加载中...</div>
      ) : items.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#999', padding: 48 }}>暂无作品</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
          <thead>
            <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #e0e0e0' }}>
              <th style={thStyle}>ID</th>
              <th style={{ ...thStyle, textAlign: 'left' }}>标题</th>
              <th style={thStyle}>行业</th>
              <th style={thStyle}>类型</th>
              <th style={thStyle}>状态</th>
              <th style={thStyle}>创建时间</th>
              <th style={thStyle}>操作</th>
            </tr>
          </thead>
          <tbody>
            {items.map(function(item) { return (
              <tr key={item.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={tdStyle}>{item.id}</td>
                <td style={{ ...tdStyle, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.title}</td>
                <td style={tdStyle}>{item.industry || '-'}</td>
                <td style={tdStyle}>{item.category === 'audio' ? '🎙️' : '🎬'}</td>
                <td style={tdStyle}>
                  <span style={{
                    display: 'inline-block', padding: '2px 10px', borderRadius: 12, fontSize: 12,
                    background: item.is_public ? '#e6ffed' : '#fff5f5',
                    color: item.is_public ? '#38a169' : '#e53e3e',
                  }}>
                    {item.is_public ? '已上架' : '已下架'}
                  </span>
                </td>
                <td style={{ ...tdStyle, fontSize: 12 }}>{item.created_at}</td>
                <td style={tdStyle}>
                  <button onClick={function() { toggleItem(item.id); }}
                    style={{ marginRight: 8, padding: '4px 12px', border: 'none', borderRadius: 6, background: item.is_public ? '#f6ad55' : '#38a169', color: '#fff', fontSize: 12, cursor: 'pointer' }}>
                    {item.is_public ? '下架' : '上架'}
                  </button>
                  <button onClick={function() { deleteItem(item.id); }}
                    style={{ padding: '4px 12px', border: 'none', borderRadius: 6, background: '#e53e3e', color: '#fff', fontSize: 12, cursor: 'pointer' }}>
                    删除
                  </button>
                </td>
              </tr>
            );})}
          </tbody>
        </table>
      )}
    </div>
  );
}

var thStyle = { padding: '12px 16px', fontSize: 13, fontWeight: 600, color: '#666', textAlign: 'center' };
var tdStyle = { padding: '12px 16px', fontSize: 13, color: '#333', textAlign: 'center' };
